import { createSlice } from "@reduxjs/toolkit";

export interface ApprovalData {
  expenseApprovalHierarchyId: number;
  orgId: number;
  projectId: number;
  reportId: number;
  userId: number;
  roleId: number;
  level: string;
  approvalStage: string;
  createdBy: number;
  createdAt: string;
  userName?: string;
  roleName?: string;
}

export interface ReportInDetailModal {
  id: string | number;
  open: boolean;
  reportName: string;
  activeTab: string;
  projectResponse: {
    id: number | null;
    name: string;
  };
  extra: {
    status: string;
    submittedDate?: string;
    approvedDate?: string;
    totalAmount?: number;
    expenses?: number;
    total?: string;
    amountToBeReimbursed?: string;
    submitter?: string;
    dateRange?: string;
    paginationId?: string;
    expenseApprovalHierarchy?: ApprovalData[];
  };
  allowEdit?: boolean;
  refreshReportBreakDown?: boolean;
  sourcePage?: string;
}

const initialState: { data: ReportInDetailModal } = {
  data: {
    id: "",
    open: false,
    reportName: "",
    activeTab: "expenses",
    projectResponse: {
      id: null,
      name: "",
    },
    extra: {
      status: "",
    },
    allowEdit: true,
  },
};

export const ReportInDetailModalSlice = createSlice({
  name: "ReportInDetailModalSlice",
  initialState,
  reducers: {
    updateReportInDetailModalSlice(state, action) {
      state.data = { ...state.data, ...action.payload };
    },
    resetReportInDetailModalSlice(state) {
      state.data = initialState.data;
    },
  },
});

export const { updateReportInDetailModalSlice, resetReportInDetailModalSlice } =
  ReportInDetailModalSlice.actions;
